import { createFileRoute, useParams } from '@tanstack/react-router';
import { Suspense } from 'react';
import HStack from '@/components/Layout/HStack';
import VStack from '@/components/Layout/VStack';
import type { NavigationSectionGroup } from '@/components/Navigation/NavigationCard';
import NavigationCard from '@/components/Navigation/NavigationCard';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useInboundDataPipelineDetail } from '../../-query';
import { BasicInfoSection } from './-components/BasicInfoSection';
export const Route = createFileRoute('/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/basic-settings/')({
  component: BasicSettings
});
function BasicSettings() {
  return <Suspense>
      <Content />
    </Suspense>;
}
function Content() {
  const {
    id
  } = useParams({
    from: '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail'
  });
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.dataConnector'
  });
  useDocumentTitle(t('inboundDataPipeline.detail.basicSettings.title'));
  const {
    data
  } = useInboundDataPipelineDetail(id);
  const navigationSections: NavigationSectionGroup[] = [{
    titleLabel: t('inboundDataPipeline.detail.basicSettings.title'),
    to: '/settings/data-connector/inbound/data-pipeline/$id/basic-settings',
    hash: 'basic-info'
  }];
  return <HStack className="gap-0 px-12 py-6">
      {/* Section Navigation Sidebar */}
      <div className="sticky top-6 w-52 shrink-0">
        <NavigationCard sections={navigationSections} />
      </div>

      {/* Main Content */}
      <VStack className="flex-1 gap-6">
        <BasicInfoSection pipelineId={id} data={data} />
      </VStack>
    </HStack>;
}